import React, { useState, useEffect } from "react";
import Preloader from "../src/components/Pre";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Projects from "./components/Projects/Projects";
import Resume from "./components/Resume/ResumeNew";
import Footer from "./components/Footer";

import { HashRouter as Router, Route, Routes, Navigate } from "react-router-dom";

import ScrollToTop from "./components/ScrollToTop";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  const [load, setLoad] = useState(true);

  // Pour s'assurer que le scroll est bloqué pendant le chargement
  useEffect(() => {
    if (load) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [load]);

  return (
    <Router>
      {/* On passe load pour l'affichage initial
          et onDone pour masquer le preloader proprement via style.css (#preloader-none)
      */}
      <div id={load ? "" : "preloader-none"}>
        <Preloader load={load} onDone={() => setLoad(false)} />
      </div>

      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <Navbar />
        <ScrollToTop />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/project" element={<Projects />} />
          <Route path="/about" element={<About />} />
          <Route path="/resume" element={<Resume />} />

          {/* Redirection automatique vers l'accueil si la route n'existe pas */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>

        <Footer />
      </div>
    </Router>
  );
}

export default App;